import { useMemo, useState } from "react";
import { useTheme } from "styled-components";
import { transformTabs } from "../utils.js";
const useSearcherTabs = (props)=>{
    const { items , config , variant  } = props ?? {};
    const theme = useTheme();
    const [selectedTab, setSelectedTab] = useState(0);
    const finalTabs = useMemo(()=>transformTabs(items, config, variant), [
        items,
        config,
        variant
    ]);
    const sliderProps = useMemo(()=>({
            autoWidth: false,
            perPage: 1,
            perMove: 1,
            breakpoints: {
                [theme.breakpoints.sm]: {
                    perPage: 2,
                    perMove: 2
                },
                [theme.breakpoints.md]: {
                    perPage: 3,
                    perMove: 3
                },
                [theme.breakpoints.lg]: {
                    perPage: 4,
                    perMove: 4
                },
                [theme.breakpoints.xl]: {
                    perPage: 5,
                    perMove: 5
                },
                [theme.breakpoints.xxl]: {
                    perPage: 6,
                    perMove: 6
                }
            },
            mediaQuery: 'min',
            wheel: true
        }), [
        theme.breakpoints
    ]);
    return {
        finalTabs,
        sliderProps,
        selectedTab,
        setSelectedTab
    };
};
export default useSearcherTabs;

//# sourceMappingURL=useSearcherTabs.js.map